/// <amd-module name="TFS/Admin/Views/ProfileSettings/AuthorizationsView/Components/AuthorizationsTableView" />
import React = require("react");
import { RevokeButtonColumn } from "TFS/Admin/Views/ProfileSettings/AuthorizationsView/Components/RevokeButtonColumn";
import { ZeroDataAuthorizationView } from "TFS/Admin/Views/ProfileSettings/AuthorizationsView/Components/ZeroDataAuthorizationView";
import { IAuthorizationsTableViewProps, IAuthorizationViewModel } from "TFS/Admin/Views/ProfileSettings/AuthorizationsView/Contracts/DataModel";
import * as Resources from "TFS/Admin/Views/ProfileSettings/AuthorizationsView/Resources";
import { IObservableValue, ObservableValue } from "VSS/Core/Observable";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { ListSelection } from "VSSUI/List";
import { Observer } from "VSSUI/Observer";
import { ITableColumn, ITableRow, SimpleTableCell, Table, TableColumnStyle } from "VSSUI/Table";
import { Tooltip } from "VSSUI/TooltipEx";

export class AuthorizationsTableView extends VssComponent<IAuthorizationsTableViewProps> {
    private _selection = new ListSelection(false);

    constructor(props: IAuthorizationsTableViewProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render() {
        return (
            <Observer itemProvider={this.props.authDataItemProvider}>
                {(props: { itemProvider: IAuthorizationViewModel[] }) => {
                    return props.itemProvider.length > 0 ? (
                        <Card className="auth-card-content" contentProps={{ contentPadding: false }}>
                            <Table
                                itemProvider={this.props.authDataItemProvider}
                                columns={this._getColumnItems()}
                                onActivate={this._onRowClicked}
                                className="authorizations-list"
                                selection={this._selection}
                                singleClickActivation={true}
                            />
                        </Card>
                    ) : (
                        <ZeroDataAuthorizationView />
                    );
                }}
            </Observer>
        );
    }

    private _onRowClicked = (e: React.SyntheticEvent<HTMLElement>, tableRow: ITableRow<any>) => {
        const appData: IAuthorizationViewModel = tableRow.data;
        this.props.getAppRowData(appData);
    };

    private _getColumnItems(): ITableColumn<any>[] {
        return [
            {
                id: "registrationName",
                name: Resources.Name,
                renderCell: this._renderDisplayNameColumn,
                width: new ObservableValue(-20),
                columnStyle: TableColumnStyle.Primary,
                onSize: this._onSizeColumn
            },
            {
                id: "companyName",
                name: Resources.CompanyName,
                renderCell: this._renderCompanyNameColumn,
                width: new ObservableValue(-20),
                columnStyle: TableColumnStyle.Secondary,
                onSize: this._onSizeColumn
            },
            {
                id: "appDescription",
                name: Resources.Description,
                renderCell: this._renderDescriptionColumn,
                width: new ObservableValue(-50),
                columnStyle: TableColumnStyle.Secondary,
                onSize: this._onSizeColumn
            },
            new RevokeButtonColumn<IAuthorizationViewModel>((item: IAuthorizationViewModel) => this.props.onRevokeClick(item))
        ];
    }

    private _onSizeColumn(event: MouseEvent, index: number, width: number, column: ITableColumn<any>) {
        (column.width as IObservableValue<number>).value = width;
    }

    private _renderDisplayNameColumn(rowIndex: number, columnIndex: number, tableColumn: ITableColumn<any>, tableItem: any): JSX.Element {
        const { authorization, clientRegistration } = tableItem.authorization;
        return (
            <SimpleTableCell
                authorization-id={authorization.authorizationId}
                columnIndex={columnIndex}
                tableColumn={tableColumn}
                key={columnIndex}
                contentClassName="display-app-name-details"
            >
                <Tooltip overflowOnly={true}>
                    <span className="text-ellipsis">{clientRegistration.registrationName}</span>
                </Tooltip>
            </SimpleTableCell>
        );
    }
    private _renderCompanyNameColumn(rowIndex: number, columnIndex: number, tableColumn: ITableColumn<any>, tableItem: any): JSX.Element {
        const { clientRegistration } = tableItem.authorization;

        return (
            <SimpleTableCell
                columnIndex={columnIndex}
                tableColumn={tableColumn}
                key={columnIndex}
                contentClassName="display-app-company-name-details"
            >
                <Tooltip overflowOnly={true}>
                    <span className="text-ellipsis">{clientRegistration.organizationName}</span>
                </Tooltip>
            </SimpleTableCell>
        );
    }
    private _renderDescriptionColumn(rowIndex: number, columnIndex: number, tableColumn: ITableColumn<any>, tableItem: any): JSX.Element {
        const { scopeDescriptions } = tableItem.authorization;
        const appDescription = scopeDescriptions
            .map((app: any) => {
                return app.description;
            })
            .join(". ");
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={columnIndex} contentClassName="display-app-description-details">
                <Tooltip overflowOnly={true}>
                    <span className="text-ellipsis">{appDescription}</span>
                </Tooltip>
            </SimpleTableCell>
        );
    }
}
